module.exports = __webpack_public_path__ + "static/media/profile.a8bda1b8.svg";